export const SHOPPING_CART_PAYMENT_METHOD_LOAD_SEND_REQUEST =
    'SHOPPING_CART_PAYMENT_METHOD_LOAD_SEND_REQUEST';
export const SHOPPING_CART_PAYMENT_METHOD_LOAD_SUCCESS_RECEIVE_RESPONSE =
    'SHOPPING_CART_PAYMENT_METHOD_LOAD_SUCCESS_RECEIVE_RESPONSE';
export const SHOPPING_CART_PAYMENT_METHOD_LOAD_FAILED_RECEIVE_RESPONSE =
    'SHOPPING_CART_PAYMENT_METHOD_LOAD_FAILED_RECEIVE_RESPONSE';
